import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { EMPTY_FUNCTION, EMPTY_OBJECT } from '../../../../constants/common'
import {
  AIButtonContainedGrey,
  AIButtonIconGrey,
  AIButtonTextGrey,
} from '../../../AIButton'
import { BUTTON_HEIGHT_20, BUTTON_HEIGHT_40 } from '../../../Button'
import {
  ICON_COLOR,
  ICON_HEIGHT_16,
  ICON_HEIGHT_20,
  IconChevron,
  IconNG,
} from '../../../Icon'
import { GRETA_PROJECT_CHATS_VISIBLE_LIMIT } from '../../GretaAIChat.constants'
import {
  getGretaAIChatExpandChevronDirection,
  getHasGretaAIChatProjectChat,
  getHasGretaAIChatProjectChats,
} from '../../GretaAIChat.utils.projects'
import { GretaAIChatProjectName } from '../../GretaAIChatProjectName'
import { GretaAIChatChatListItem } from '../GretaAIChatChatListItem'

import {
  QA_NAME_GRETA_AI_CHAT_PROJECT,
  QA_NAME_GRETA_AI_CHAT_PROJECT_CHATS_ALL,
  QA_NAME_GRETA_AI_CHAT_PROJECT_TOGGLE,
} from './GretaAIChatChatListProject.constants'
import { getHasGretaAIChatProjectHiddenChats } from './GretaAIChatChatListProject.utils'

import * as styles from './GretaAIChatChatListProject.module.css'

import FolderIcon from '../../../../icons/folder.svg'

function GretaAIChatChatListProject({
  activeChatId,
  chatStatusById = EMPTY_OBJECT,
  isExpanded = false,
  isFull = false,
  locale,
  now,
  project: { chats, id, name },
  withRowActions = true,
  onSelectChat = EMPTY_FUNCTION,
  onShowAllChats = EMPTY_FUNCTION,
  onToggle = EMPTY_FUNCTION,
}) {
  const { t } = useTranslation()

  const hasChats = getHasGretaAIChatProjectChats(chats)
  const isActive =
    !isExpanded && getHasGretaAIChatProjectChat(chats, activeChatId)

  const visibleChats = isFull
    ? chats
    : chats.slice(0, GRETA_PROJECT_CHATS_VISIBLE_LIMIT)
  const hasHiddenChats = getHasGretaAIChatProjectHiddenChats({
    chats,
    visibleChats,
  })
  const chevronDirection = getGretaAIChatExpandChevronDirection(isExpanded)

  function handleToggle() {
    onToggle(id)
  }

  function handleShowAllChats() {
    onShowAllChats(id)
  }

  return (
    <li>
      <div className={styles.row}>
        <span className={styles.toggle}>
          <IconNG
            Icon={FolderIcon}
            className={styles.folderIcon}
            color={ICON_COLOR.SecondaryTextColor}
            size={ICON_HEIGHT_20}
          />
          {hasChats ? (
            <AIButtonIconGrey
              Icon={IconChevron}
              beforeIconProps={{
                height: ICON_HEIGHT_16,
                iconProps: { direction: chevronDirection },
              }}
              className={styles.chevron}
              height={BUTTON_HEIGHT_20}
              qaName={QA_NAME_GRETA_AI_CHAT_PROJECT_TOGGLE}
              onClick={handleToggle}
            />
          ) : null}
        </span>
        <AIButtonContainedGrey
          className={classNames(styles.project, {
            [styles.projectActive]: isActive,
          })}
          height={BUTTON_HEIGHT_40}
          qaName={QA_NAME_GRETA_AI_CHAT_PROJECT}
        >
          <GretaAIChatProjectName className={styles.projectName} name={name} />
        </AIButtonContainedGrey>
      </div>
      {isExpanded ? (
        <ul className={styles.chats}>
          {visibleChats.map(chat => (
            <GretaAIChatChatListItem
              isNested
              chat={chat}
              isActive={chat.id === activeChatId}
              key={chat.id}
              locale={locale}
              now={now}
              status={chatStatusById[chat.id] ?? null}
              withRowActions={withRowActions}
              onSelect={onSelectChat}
            />
          ))}
          {hasHiddenChats ? (
            <li className={styles.showAllChats}>
              <AIButtonTextGrey
                qaName={QA_NAME_GRETA_AI_CHAT_PROJECT_CHATS_ALL}
                text={t('Greta.ProjectChatsShowAllKey')}
                onClick={handleShowAllChats}
              />
            </li>
          ) : null}
        </ul>
      ) : null}
    </li>
  )
}

export default GretaAIChatChatListProject
